import React from 'react';
import SEO from '../../common/SEO';
import Layout from '../../common/Layout';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import AboutSeven from '../../components/about/AboutSeven';
import AboutUsOneService from '../../components/about-us-one/AboutUsOneService';
import AboutOne from '../../components/about/AboutThree';

const AboutUsOne = () => {
    return (
        <>
            <SEO title="About Us" />

            <Layout>
                <BreadcrumbOne
                    title="About Green Cap High School"
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="About Us"
                />

                <AboutSeven />

                <AboutUsOneService />

                <AboutOne />
            </Layout>
        </>
    )
}

export default AboutUsOne;
